<template>
    <div class="page">


        <div class="card" style="margin-bottom: 2vw;padding: 2vw">
            <h1 style="font-size: 5vw">用户绑定</h1>
        </div>

        <div class="card">

            <div class="col">
                <span class="title">户名</span>
                <label class="input" :class="{no:!rule.name}"><input @blur="aaa('name')" v-model="form.name"
                                                                     placeholder="请输入户名" type="text"/></label>
            </div>

            <div class="col">
                <span class="title">用户编码</span>
                <label class="input" :class="{no:!rule.NO}"><input @blur="aaa('NO')" v-model="form.NO"
                                                                   placeholder="请输入用户编码" type="text"/></label>
            </div>

            <div class="btn-block">

                <span @click="onSubmit">绑定</span>
                <span @click="onClose">返回</span>

            </div>

        </div>

    </div>
</template>

<script>
    import {bindMember} from "../api/api";
    import {Indicator} from 'mint-ui';

    export default {
        name: "Bind"
        , data() {
            return {
                form: {
                    name: ''
                    , NO: ''
                }
                , rule: {
                    name: true
                    , NO: true
                }

            }
        }, methods: {
            aaa(a) {
                if (!this.form[a]) {
                    this.rule[a] = false;
                    // console.log(a);
                }

            },
            checkRules() {

                let result = true;

                for (var x in this.form) {
                    if (!this.form[x]) {
                        this.rule[x] = false;
                        result = false;
                    }
                }

                return result;

            },
            onSubmit() {

                // if (!this.form.name) {
                //
                // }
                //
                if (this.checkRules()) {

                    Indicator.open('绑定中...');

                    bindMember(this.form).then(res => {
                        this.$toast({
                            message: '绑定成功',
                            position: 'bottom',
                            duration: 5000
                        })
                        Indicator.close();
                        this.$router.push({
                            path: '/'
                        });

                    }).catch(res => {
                        Indicator.close();
                    });

                }




            }, onClose() {

                this.$router.push({
                    path:'/'
                });

            }

        }
    }
</script>

<style scoped>

    .page {
        padding: 5vw;
    }

    .card {
        background-color: #fff;
        padding: 5vw;
        border-radius: 5px;
    }

    .col {
        padding: 3vw 0;
        border-bottom: 1px solid #e5e5e5;
    }

    .title {
        font-size: 4vw;
        display: inline-block;
        width: 18vw;
    }

    .input input {
        font-size: 4vw;
    }

    .btn-block {
        display: flex;
        flex-direction: column;
        margin-top: 5vw;
        align-items: center;
        justify-content: center;
    }

    .btn-block span {
        margin-bottom: 2vw;
        text-align: center;
        display: inline-block;
        width: 80vw;
        background-color: #3e94ff;
        color: #fff;
        padding: 2vw 0;
        border-radius: 5px;
    }

    .no input::-webkit-input-placeholder {
        /* placeholder颜色  */
        color: #ff5f5d;

    }

</style>